import { useContext } from "react";
import { ClinicThemeContext } from "./ClinicThemeProvider";
import { generatePalette } from "./themeUtils";
import { DEFAULT_PRIMARY } from "./palettes";

const fallbackPalette = generatePalette(DEFAULT_PRIMARY);

/**
 * Klinik temasına erişim hook'u.
 *
 * Kullanım:
 *   const { palette } = useClinicTheme();
 *   <Box sx={{ color: palette.primary }}>
 *
 * Dönen değerler:
 *   palette       – generatePalette() çıktısı (colors.js ile aynı key'ler)
 *   clinicColor   – DB'den gelen ham hex (null ise default)
 *   isCustomTheme – Klinik özel renk seçmiş mi?
 */
export default function useClinicTheme() {
  const ctx = useContext(ClinicThemeContext);

  if (!ctx) {
    return {
      palette: fallbackPalette,
      clinicColor: null,
      isCustomTheme: false,
    };
  }

  return ctx;
}
